import pt_BR from './pt_BR.json';
import en_US from './en_US.json';
import es_ES from './es_ES.json';

function getLanguageFromLocalStorage() {
    return window.localStorage.getItem('language') || 'pt_BR';
}

const Locales = {
    getTranslations: () => {
        const language = getLanguageFromLocalStorage();
        const locales = {
            pt_BR,
            en_US,
            es_ES
        }
        return locales[language];
    },
    getCurrentLanguage: () => {
        return getLanguageFromLocalStorage();
    },
}




export default Locales;